import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface HelpIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const HelpIcon = ({ color = RoutalPalette.secondary40, style = {}, ...props }: HelpIconProps) => {
  const { width = `20px`, height = `20px` } = style;
  return (
    <SvgIcon {...props} viewBox="0 0 21 20" style={{ width, height, ...style }}>
      <g>
        <rect x="0.169922" width={width} height={height} rx="4" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1699 15C12.9313 15 15.1699 12.7614 15.1699 10C15.1699 7.23857 12.9313 5 10.1699 5C7.4085 5 5.16992 7.23857 5.16992 10C5.16992 10.7998 5.35773 11.5558 5.69165 12.2262C5.78039 12.4044 5.80993 12.608 5.75848 12.8003L5.46068 13.9134C5.3314 14.3965 5.77343 14.8385 6.2566 14.7093L7.36962 14.4115C7.56189 14.36 7.76553 14.3895 7.94369 14.4782C8.61411 14.8122 9.37007 15 10.1699 15ZM8.16992 10.625C7.96282 10.625 7.79492 10.7929 7.79492 11C7.79492 11.2071 7.96282 11.375 8.16992 11.375H10.9199C11.127 11.375 11.2949 11.2071 11.2949 11C11.2949 10.7929 11.127 10.625 10.9199 10.625H8.16992ZM7.79492 9.25C7.79492 9.0429 7.96282 8.875 8.16992 8.875H12.1699C12.377 8.875 12.5449 9.0429 12.5449 9.25C12.5449 9.4571 12.377 9.625 12.1699 9.625H8.16992C7.96282 9.625 7.79492 9.4571 7.79492 9.25Z"
          fill={RoutalPalette.white}
        />
      </g>
    </SvgIcon>
  );
};
